import type { FaireProductEntity } from "../../entity_types/product";

export const bath_8: FaireProductEntity = {
  token: "bath-8",
  type: "product",
  name: "Coconut Oil Body Scrub",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/063dc0dc2c87f13b1502d284bdd1a8d8131f156cf92bb254353ad050e51690ec.webp",
  priceDollars: 13,
  msrpDollars: 21,
  freeShipping: false,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
